import confetti from 'canvas-confetti';

// Celebration confetti for gift sending or reward earning - GOLD theme
export const celebrateGift = () => {
  const duration = 3000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

  const randomInRange = (min, max) => Math.random() * (max - min) + min;

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    // Shoot confetti from both sides - Gold & Green luxury colors
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      colors: ['#C3A365', '#D4B876', '#145A3A', '#1A734A', '#E8EBE9']
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      colors: ['#C3A365', '#D4B876', '#145A3A', '#1A734A', '#E8EBE9']
    });
  }, 250);
};

// Subtle sparkle for points earned - GOLD theme
export const sparklePoints = () => {
  confetti({
    particleCount: 50,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#C3A365', '#D4B876', '#E5C987', '#B8956E', '#A6845D'],
    ticks: 150,
    gravity: 0.8,
    scalar: 1.2,
    shapes: ['circle', 'square'],
    zIndex: 9999
  });
};

// Fireworks for major achievements
export const fireworks = () => {
  const duration = 5000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 45, spread: 360, ticks: 100, zIndex: 9999 };

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    confetti({
      ...defaults,
      particleCount: 100,
      origin: { x: Math.random(), y: Math.random() - 0.2 },
      colors: ['#E5E7EB', '#9CA3AF', '#6B7280', '#10B981', '#3B82F6']
    });
  }, 400);
};

// Side cannons effect
export const sideCannons = () => {
  const end = Date.now() + 1000;

  const colors = ['#E5E7EB', '#9CA3AF', '#6B7280'];

  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
      zIndex: 9999
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
      zIndex: 9999
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  }());
};

export default {
  celebrateGift,
  sparklePoints,
  fireworks,
  sideCannons
};
